import { getLocale } from '@/utils/localStorage';
import { LOCALES } from '@/utils/constants';

const locale = getLocale();

export function getLabel(choice) {
  return locale === LOCALES.en && choice.label_en ? choice.label_en : choice.label;
}
